import url from 'libraries/front-end-core/core/url'
import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { DOCUMENTS_CONTENT, DOCUMENTS_MENU } from 'constants/controllers'

// precedentId was only used for precedents admin view which no longer lives in this codebase

export default new Controller({
  name: 'LegacyDocumentsRedirect',
  /* route: ':aol/precedents/:view(/:sectionId(/e/:expanded)(/:precedentId))', */
  // precedentId was only used in admin which is longer in this codebase
  route: 'corporate/documents/:view(/:sectionId(/e/:expanded))',
  controller (Router, { params: { sectionId, expanded } }) {
    const target = url(
      sectionId === undefined
        ? DOCUMENTS_MENU
        : DOCUMENTS_CONTENT,
      {
        sectionId,
        focusedId: expanded
      }
    )
    replaceUrl(target)
  }
})
